/* 自动生成，不要手改。
 *
 * 生成命令：node tools/gen-settings-registry.mjs
 * 数据来源：design-prototype/schema.js
 *
 * 每一页每张卡片的**全部**行，包括没有 k 的：说明、小标题、按钮、定制块、折叠组。
 * 设置项本身（类型、默认值、校验）在 registry.generated.ts，这里只按 key 引用。
 *
 * 当前统计：卡片 76 张；
 *   设置项行 327、说明 9、小标题 10、
 *   按钮排 41、定制块 53、折叠组 5
 */

import type { CardSpec } from './cards.ts';

export const CARD_SPECS: Readonly<Record<string, readonly CardSpec[]>> = {
  "home": [],
  "inbox": [],
  "rules": [
    {
      "id": "rules:1",
      "page": "rules",
      "no": 1,
      "title": {
        "zh": "利润锁死机制",
        "hk": "利潤鎖死機制",
        "en": "Profit lock"
      },
      "sub": {
        "zh": "赚到一定金额就强制提现一部分，防止盈利回吐",
        "hk": "賺到一定金額就強制提現一部分，防止盈利回吐",
        "en": "Force a withdrawal once profit hits a threshold"
      },
      "rows": [
        {
          "t": "key",
          "key": "pl_enabled"
        },
        {
          "t": "key",
          "key": "pl_trigger"
        },
        {
          "t": "key",
          "key": "pl_percent"
        },
        {
          "t": "key",
          "key": "pl_deadline"
        },
        {
          "t": "key",
          "key": "pl_nag"
        },
        {
          "t": "key",
          "key": "pl_fs"
        },
        {
          "t": "key",
          "key": "pl_sound"
        }
      ]
    },
    {
      "id": "rules:3",
      "page": "rules",
      "no": 3,
      "title": {
        "zh": "手感极佳警报",
        "hk": "手感極佳警報",
        "en": "Hot-hand alert"
      },
      "sub": {
        "zh": "连胜之后最容易上头，强制休眠一段时间",
        "hk": "連勝之後最容易上頭，強制休眠一段時間",
        "en": "Winning streaks invite overconfidence: force a break"
      },
      "rows": [
        {
          "t": "key",
          "key": "hh_enabled"
        },
        {
          "t": "key",
          "key": "hh_streak"
        },
        {
          "t": "key",
          "key": "hh_sleepMin"
        },
        {
          "t": "key",
          "key": "hh_presets"
        },
        {
          "t": "key",
          "key": "hh_lock"
        },
        {
          "t": "key",
          "key": "hh_shutdown"
        },
        {
          "t": "key",
          "key": "hh_directExit"
        },
        {
          "t": "key",
          "key": "hh_reqPhrase"
        },
        {
          "t": "key",
          "key": "hh_minLock"
        },
        {
          "t": "key",
          "key": "hh_phrase"
        }
      ]
    },
    {
      "id": "rules:4",
      "page": "rules",
      "no": 4,
      "title": {
        "zh": "回撤熔断线",
        "hk": "回撤熔斷線",
        "en": "Drawdown breaker"
      },
      "sub": {
        "zh": "从高点回撤多少、连亏几笔、单日亏多少就强制停手",
        "hk": "由高點回撤多少、連虧幾筆、單日虧多少就強制停手",
        "en": "Stop trading on drawdown, losing streak or daily loss"
      },
      "rows": [
        {
          "t": "key",
          "key": "db_enabled"
        },
        {
          "t": "key",
          "key": "db_dd"
        },
        {
          "t": "key",
          "key": "db_basis"
        },
        {
          "t": "key",
          "key": "db_minPeak"
        },
        {
          "t": "key",
          "key": "db_loss"
        },
        {
          "t": "key",
          "key": "db_maxloss"
        },
        {
          "t": "key",
          "key": "db_mode"
        },
        {
          "t": "key",
          "key": "db_duration"
        },
        {
          "t": "key",
          "key": "db_presets"
        },
        {
          "t": "key",
          "key": "db_lock"
        },
        {
          "t": "key",
          "key": "db_blockSites"
        },
        {
          "t": "key",
          "key": "db_shutdown"
        },
        {
          "t": "key",
          "key": "db_directExit"
        },
        {
          "t": "key",
          "key": "db_reqPhrase"
        },
        {
          "t": "key",
          "key": "db_minLock"
        },
        {
          "t": "key",
          "key": "db_phrase"
        }
      ]
    },
    {
      "id": "rules:5",
      "page": "rules",
      "no": 5,
      "title": {
        "zh": "极度耐心提醒（循环）",
        "hk": "極度耐心提醒（循環）",
        "en": "Patience reminder"
      },
      "sub": {
        "zh": "按间隔循环提醒你不要急着开仓",
        "hk": "按間隔循環提醒你不要急著開倉",
        "en": "Periodic nudges to wait"
      },
      "rows": [
        {
          "t": "key",
          "key": "pa_enabled"
        },
        {
          "t": "key",
          "key": "pa_interval"
        },
        {
          "t": "key",
          "key": "pa_duration"
        },
        {
          "t": "key",
          "key": "pa_from"
        },
        {
          "t": "key",
          "key": "pa_to"
        },
        {
          "t": "key",
          "key": "pa_style"
        },
        {
          "t": "key",
          "key": "pa_msgs"
        },
        {
          "t": "key",
          "key": "pa_sound"
        },
        {
          "t": "key",
          "key": "pa_voice"
        }
      ]
    },
    {
      "id": "rules:6",
      "page": "rules",
      "no": 6,
      "title": {
        "zh": "每日核心心法",
        "hk": "每日核心心法",
        "en": "Daily creed"
      },
      "sub": {
        "zh": "固定时间点或按间隔展示，可要求抄写、可语音播报",
        "hk": "固定時間點或按間隔顯示，可要求抄寫、可語音播報",
        "en": "Show your creed at fixed times or intervals"
      },
      "rows": [
        {
          "t": "key",
          "key": "cr_enabled"
        },
        {
          "t": "key",
          "key": "cr_text"
        },
        {
          "t": "key",
          "key": "cr_quoteMode"
        },
        {
          "t": "key",
          "key": "cr_quoteEvery"
        },
        {
          "t": "key",
          "key": "cr_useTimes"
        },
        {
          "t": "key",
          "key": "cr_times"
        },
        {
          "t": "key",
          "key": "cr_useInterval"
        },
        {
          "t": "key",
          "key": "cr_interval"
        },
        {
          "t": "key",
          "key": "cr_from"
        },
        {
          "t": "key",
          "key": "cr_to"
        },
        {
          "t": "key",
          "key": "cr_typing"
        },
        {
          "t": "key",
          "key": "cr_typingSource"
        },
        {
          "t": "key",
          "key": "cr_typingTimeout"
        },
        {
          "t": "key",
          "key": "cr_typingList"
        },
        {
          "t": "key",
          "key": "cr_speak"
        },
        {
          "t": "key",
          "key": "cr_speakSource"
        },
        {
          "t": "key",
          "key": "cr_speakList"
        },
        {
          "t": "key",
          "key": "cr_fs"
        }
      ]
    },
    {
      "id": "rules:7",
      "page": "rules",
      "no": 7,
      "title": {
        "zh": "未处理时的重复催办",
        "hk": "未處理時的重複催辦",
        "en": "Nagging"
      },
      "sub": {
        "zh": "你把提醒点掉但没真去做，它会一直追着你",
        "hk": "你把提醒點掉但沒真去做，它會一直追著你",
        "en": "Keeps chasing you until you actually act"
      },
      "rows": [
        {
          "t": "key",
          "key": "ng_enabled"
        },
        {
          "t": "key",
          "key": "ng_profit"
        },
        {
          "t": "key",
          "key": "ng_hot"
        },
        {
          "t": "key",
          "key": "ng_breaker"
        },
        {
          "t": "key",
          "key": "ng_creed"
        },
        {
          "t": "key",
          "key": "ng_sitting"
        },
        {
          "t": "key",
          "key": "ng_reminder"
        },
        {
          "t": "key",
          "key": "ng_max"
        },
        {
          "t": "key",
          "key": "ng_escalate"
        },
        {
          "t": "key",
          "key": "ng_escAfter"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存 5 重纪律设置",
                "hk": "儲存 5 重紀律設定",
                "en": "Save discipline settings"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "rules:8",
      "page": "rules",
      "no": 8,
      "title": {
        "zh": "R 倍数口径（决定期望值准不准）",
        "hk": "R 倍數口徑（決定期望值準不準）",
        "en": "R multiple basis"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "ps_stop"
        },
        {
          "t": "key",
          "key": "ps_riskBasis"
        },
        {
          "t": "note",
          "text": {
            "zh": "原来的仓位计算器已整块移除：它依赖\"总资金\"，而这个字段长期为空，点计算永远报错。",
            "hk": "原本的倉位計算器已整塊移除：它依賴「總資金」，而這個欄位長期為空，按計算永遠報錯。",
            "en": "The old position-size calculator was removed: it depended on a total-capital field that was always empty."
          },
          "dep": null
        }
      ]
    },
    {
      "id": "rules:9",
      "page": "rules",
      "no": 9,
      "title": {
        "zh": "期望值分析",
        "hk": "期望值分析",
        "en": "Expectancy"
      },
      "sub": {
        "zh": "26 项统计：胜率、盈亏比、期望值 R、SQN、Profit Factor、最大回撤、最长连亏……",
        "hk": "26 項統計：勝率、盈虧比、期望值 R、SQN、Profit Factor、最大回撤、最長連虧……",
        "en": "26 metrics: win rate, payoff ratio, expectancy R, SQN, profit factor, max drawdown, longest losing streak"
      },
      "rows": [
        {
          "t": "key",
          "key": "exp_days"
        },
        {
          "t": "key",
          "key": "exp_target"
        },
        {
          "t": "key",
          "key": "exp_alert"
        },
        {
          "t": "key",
          "key": "exp_minSample"
        },
        {
          "t": "key",
          "key": "exp_checkMin"
        },
        {
          "t": "custom",
          "name": "expResult",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "rules:11",
      "page": "rules",
      "no": 11,
      "title": {
        "zh": "交易频率上限",
        "hk": "交易頻率上限",
        "en": "Trade frequency cap"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "tf_enabled"
        },
        {
          "t": "key",
          "key": "tf_day"
        },
        {
          "t": "key",
          "key": "tf_hour"
        },
        {
          "t": "key",
          "key": "tf_onExceed"
        },
        {
          "t": "key",
          "key": "tf_minutes"
        },
        {
          "t": "custom",
          "name": "freqResult",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "rules:12",
      "page": "rules",
      "no": 12,
      "title": {
        "zh": "FOMO 抵抗统计",
        "hk": "FOMO 抵抗統計",
        "en": "FOMO resistance"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "fomoStats",
          "dep": null
        }
      ]
    },
    {
      "id": "rules:13",
      "page": "rules",
      "no": 13,
      "title": {
        "zh": "手动补录一次抵抗",
        "hk": "手動補錄一次抵抗",
        "en": "Log a resisted trade"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "mf_token"
        },
        {
          "t": "key",
          "key": "mf_symbol"
        },
        {
          "t": "key",
          "key": "mf_chain"
        },
        {
          "t": "key",
          "key": "mf_reason"
        },
        {
          "t": "key",
          "key": "mf_mc"
        },
        {
          "t": "key",
          "key": "mf_note"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "记录这次抵抗",
                "hk": "記錄這次抵抗",
                "en": "Log it"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "清空全部记录",
                "hk": "清空全部記錄",
                "en": "Clear all"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "rules:14",
      "page": "rules",
      "no": 14,
      "title": {
        "zh": "抵抗记录",
        "hk": "抵抗記錄",
        "en": "Resistance log"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "fomoDays"
        },
        {
          "t": "key",
          "key": "fomoFilter"
        },
        {
          "t": "key",
          "key": "fomoSearch"
        },
        {
          "t": "custom",
          "name": "fomoList",
          "dep": null
        }
      ]
    },
    {
      "id": "rules:15",
      "page": "rules",
      "no": 15,
      "title": {
        "zh": "FOMO 设置",
        "hk": "FOMO 設定",
        "en": "FOMO settings"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "fr_enabled"
        },
        {
          "t": "key",
          "key": "fr_reqToken"
        },
        {
          "t": "key",
          "key": "fr_reqReason"
        },
        {
          "t": "key",
          "key": "fr_reviewHours"
        },
        {
          "t": "key",
          "key": "fr_milestones"
        },
        {
          "t": "key",
          "key": "fr_reasons"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "rules:16",
      "page": "rules",
      "no": 16,
      "title": {
        "zh": "久坐运动提醒",
        "hk": "久坐運動提醒",
        "en": "Sitting reminder"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "st_enabled"
        },
        {
          "t": "key",
          "key": "st_interval"
        },
        {
          "t": "key",
          "key": "st_break"
        },
        {
          "t": "key",
          "key": "st_idle"
        },
        {
          "t": "key",
          "key": "st_tips"
        },
        {
          "t": "key",
          "key": "st_fs"
        },
        {
          "t": "key",
          "key": "st_sound"
        },
        {
          "t": "key",
          "key": "st_voice"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    }
  ],
  "wallet": [
    {
      "id": "基础设置",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "基础设置",
        "hk": "基礎設定",
        "en": "Basics"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "gm_enabled"
        },
        {
          "t": "key",
          "key": "gm_poll"
        },
        {
          "t": "key",
          "key": "gm_fastEnabled"
        },
        {
          "t": "key",
          "key": "gm_fastPoll"
        },
        {
          "t": "key",
          "key": "gm_fastDur"
        },
        {
          "t": "key",
          "key": "gm_period"
        },
        {
          "t": "key",
          "key": "gm_actInt"
        }
      ]
    },
    {
      "id": "接口额度与限流",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "接口额度与限流",
        "hk": "介面額度與限流",
        "en": "Quota & rate limit"
      },
      "sub": {
        "zh": "宁慢勿限速：默认只用免费额度的 30%，两次请求至少隔 1 秒",
        "hk": "寧慢勿限速：預設只用免費額度的 30%，兩次請求至少隔 1 秒",
        "en": "Slower beats rate-limited"
      },
      "rows": [
        {
          "t": "key",
          "key": "gm_tier"
        },
        {
          "t": "key",
          "key": "gm_safety"
        },
        {
          "t": "key",
          "key": "gm_minGap"
        },
        {
          "t": "key",
          "key": "gm_burst"
        },
        {
          "t": "custom",
          "name": "limiterState",
          "dep": null
        }
      ]
    },
    {
      "id": "API Key 池（轮换使用）",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "API Key 池（轮换使用）",
        "hk": "API Key 池（輪換使用）",
        "en": "API key pool"
      },
      "sub": {
        "zh": "多 Key 的真实作用是故障转移，不叠加额度（GMGN 按 Key 或 IP 限流）",
        "hk": "多 Key 的真實作用是故障轉移，不疊加額度（GMGN 按 Key 或 IP 限流）",
        "en": "Multiple keys give failover, not more quota"
      },
      "rows": [
        {
          "t": "key",
          "key": "gm_rotation"
        },
        {
          "t": "key",
          "key": "gm_usePk"
        },
        {
          "t": "custom",
          "name": "keyList",
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "添加 / 编辑 Key",
            "hk": "新增 / 編輯 Key",
            "en": "Add / edit key"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "k_label"
        },
        {
          "t": "key",
          "key": "k_apiKey"
        },
        {
          "t": "key",
          "key": "k_privateKey"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "通过向导连接 GMGN",
                "hk": "透過嚮導連接 GMGN",
                "en": "Connect via wizard"
              },
              "act": "wizard",
              "primary": true
            },
            {
              "label": {
                "zh": "测试全部 Key",
                "hk": "測試全部 Key",
                "en": "Test all keys"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "显示 / 隐藏完整内容",
                "hk": "顯示 / 隱藏完整內容",
                "en": "Show / hide"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "额度消耗预估",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "额度消耗预估",
        "hk": "額度消耗預估",
        "en": "Quota forecast"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "usageBox",
          "dep": null
        }
      ]
    },
    {
      "id": "网络与出口",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "网络与出口",
        "hk": "網絡與出口",
        "en": "Network & egress"
      },
      "sub": {
        "zh": "桌面版这里是本机代理设置；网页版换成\"请求从哪里发出\"",
        "hk": "桌面版這裏是本機代理設定；網頁版換成「請求由哪裏發出」",
        "en": "Desktop had local proxy settings; the web version chooses where requests originate"
      },
      "rows": [
        {
          "t": "key",
          "key": "net_origin"
        },
        {
          "t": "key",
          "key": "net_fallback"
        },
        {
          "t": "key",
          "key": "net_v4"
        },
        {
          "t": "custom",
          "name": "egressBox",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "重新测试连通性",
                "hk": "重新測試連通性",
                "en": "Re-test connectivity"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "监控钱包",
      "page": "wallet",
      "no": null,
      "title": {
        "zh": "监控钱包",
        "hk": "監控錢包",
        "en": "Monitored wallets"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "usageWallets",
          "dep": null
        },
        {
          "t": "custom",
          "name": "walletList",
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "添加钱包",
            "hk": "新增錢包",
            "en": "Add wallet"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "w_chain"
        },
        {
          "t": "key",
          "key": "w_label"
        },
        {
          "t": "key",
          "key": "w_addr"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "添加钱包",
                "hk": "新增錢包",
                "en": "Add wallet"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "保存钱包监控设置",
                "hk": "儲存錢包監控設定",
                "en": "Save"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    }
  ],
  "tokenwatch": [
    {
      "id": "总开关与检查频率",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "总开关与检查频率",
        "hk": "總開關與檢查頻率",
        "en": "Master switch & frequency"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "tw_enabled"
        },
        {
          "t": "key",
          "key": "tw_pollSec"
        },
        {
          "t": "custom",
          "name": "twQuota",
          "dep": null
        }
      ]
    },
    {
      "id": "添加要监控的代币",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "添加要监控的代币",
        "hk": "新增要監控的代幣",
        "en": "Add a token"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "tw_chain"
        },
        {
          "t": "key",
          "key": "tw_address"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "查一下（先验证链选对没）",
                "hk": "查一下（先驗證鏈選對沒）",
                "en": "Probe"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "custom",
          "name": "twProbe",
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "涨跌规则",
            "hk": "漲跌規則",
            "en": "Step rules"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "tw_upEnabled"
        },
        {
          "t": "key",
          "key": "tw_upStep"
        },
        {
          "t": "key",
          "key": "tw_downEnabled"
        },
        {
          "t": "key",
          "key": "tw_downStep"
        },
        {
          "t": "key",
          "key": "tw_anchorMode"
        },
        {
          "t": "key",
          "key": "tw_cooldown"
        },
        {
          "t": "key",
          "key": "tw_maxNotif"
        },
        {
          "t": "key",
          "key": "tw_minLiq"
        },
        {
          "t": "key",
          "key": "tw_targetAbove"
        },
        {
          "t": "key",
          "key": "tw_targetBelow"
        },
        {
          "t": "key",
          "key": "tw_mcAbove"
        },
        {
          "t": "key",
          "key": "tw_mcBelow"
        },
        {
          "t": "key",
          "key": "tw_note"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "加入监控",
                "hk": "加入監控",
                "en": "Add"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "取消修改",
                "hk": "取消修改",
                "en": "Cancel"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "监控中的代币",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "监控中的代币",
        "hk": "監控中的代幣",
        "en": "Watched tokens"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "立即检查一轮",
                "hk": "立即檢查一輪",
                "en": "Poll now"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "发一条测试通知",
                "hk": "發一條測試通知",
                "en": "Send test alert"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "custom",
          "name": "twList",
          "dep": null
        }
      ]
    },
    {
      "id": "价格通知发到哪里",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "价格通知发到哪里",
        "hk": "價格通知發到哪裏",
        "en": "Where alerts go"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "tw_channelMode"
        },
        {
          "t": "key",
          "key": "tw_ch"
        },
        {
          "t": "custom",
          "name": "twChDesc",
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "独立配置（留空 = 沿用共享）",
            "hk": "獨立設定（留空 = 沿用共享）",
            "en": "Separate config (blank = inherit)"
          },
          "dep": {
            "key": "tw_channelMode",
            "op": "eq",
            "value": "own"
          }
        },
        {
          "t": "key",
          "key": "tw_own_tg_chatId"
        },
        {
          "t": "key",
          "key": "tw_own_tg_botToken"
        },
        {
          "t": "key",
          "key": "tw_own_fs_webhook"
        },
        {
          "t": "key",
          "key": "tw_own_bark_key"
        },
        {
          "t": "sect",
          "text": {
            "zh": "Bark 强度",
            "hk": "Bark 強度",
            "en": "Bark intensity"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "tw_bark_level"
        },
        {
          "t": "key",
          "key": "tw_bark_crashLevel"
        },
        {
          "t": "key",
          "key": "tw_bark_call"
        }
      ]
    },
    {
      "id": "静默时段与全局门槛",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "静默时段与全局门槛",
        "hk": "靜默時段與全域門檻",
        "en": "Quiet hours & global floor"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "tw_quietEnabled"
        },
        {
          "t": "key",
          "key": "tw_quietFrom"
        },
        {
          "t": "key",
          "key": "tw_quietTo"
        },
        {
          "t": "key",
          "key": "tw_minLiqGlobal"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "发过的价格通知",
      "page": "tokenwatch",
      "no": null,
      "title": {
        "zh": "发过的价格通知",
        "hk": "發過的價格通知",
        "en": "Alert history"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "twLog",
          "dep": null
        }
      ]
    }
  ],
  "chain": [],
  "reminders": [
    {
      "id": "新增事项",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "新增事项",
        "hk": "新增事項",
        "en": "New reminder"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "ri_title"
        },
        {
          "t": "key",
          "key": "ri_link"
        },
        {
          "t": "key",
          "key": "ri_note"
        },
        {
          "t": "key",
          "key": "ri_whenDate"
        },
        {
          "t": "key",
          "key": "ri_whenTime"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "今天",
                "hk": "今天",
                "en": "Today"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "明天",
                "hk": "明天",
                "en": "Tomorrow"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "3 天后",
                "hk": "3 天後",
                "en": "In 3d"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "1 周后",
                "hk": "1 週後",
                "en": "In 1w"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "下个月同一天",
                "hk": "下個月同一天",
                "en": "Next month"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "现在",
                "hk": "現在",
                "en": "Now"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "09:00",
                "hk": "09:00",
                "en": "09:00"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "12:00",
                "hk": "12:00",
                "en": "12:00"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "18:00",
                "hk": "18:00",
                "en": "18:00"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "20:00",
                "hk": "20:00",
                "en": "20:00"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "22:00",
                "hk": "22:00",
                "en": "22:00"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "key",
          "key": "ri_repeat"
        },
        {
          "t": "sect",
          "text": {
            "zh": "提前提醒（可多选）",
            "hk": "提前提醒（可多選）",
            "en": "Lead times (multiple)"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "ri_lead"
        },
        {
          "t": "key",
          "key": "ri_leadCustom"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "添加事项",
                "hk": "新增事項",
                "en": "Add"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "取消编辑",
                "hk": "取消編輯",
                "en": "Cancel"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "事项列表",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "事项列表",
        "hk": "事項列表",
        "en": "Reminder list"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "usageReminders",
          "dep": null
        },
        {
          "t": "key",
          "key": "ri_filter"
        },
        {
          "t": "custom",
          "name": "reminderList",
          "dep": null
        }
      ]
    },
    {
      "id": "通知通道与时机矩阵",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "通知通道与时机矩阵",
        "hk": "通知通道與時機矩陣",
        "en": "Channel × phase matrix"
      },
      "sub": {
        "zh": "每个通道在提前、到点、催办三个时机里发哪几个。页面里的弹窗和语音不受这里管。",
        "hk": "每個通道在提前、到點、催辦三個時機裏發哪幾個。頁面裏的彈窗和語音不受這裏管。",
        "en": "Which moments (lead, due, nag) each channel is used for. In-page popups and voice are not affected."
      },
      "rows": [
        {
          "t": "key",
          "key": "rm_phaseCh"
        }
      ]
    },
    {
      "id": "到点没处理时的反复催办",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "到点没处理时的反复催办",
        "hk": "到點沒處理時的反復催辦",
        "en": "Due-time nagging"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "dn_enabled"
        },
        {
          "t": "key",
          "key": "dn_maxRepeats"
        },
        {
          "t": "key",
          "key": "dn_intervalMin"
        },
        {
          "t": "note",
          "text": {
            "zh": "标记完成 / 延后 / 删除会立刻停止催办，并取消未发出的 Bark 连发。",
            "hk": "標記完成 / 延後 / 刪除會立刻停止催辦，並取消未發出的 Bark 連發。",
            "en": "Completing, snoozing or deleting stops the nagging and cancels queued Bark pushes."
          },
          "dep": null
        }
      ]
    },
    {
      "id": "Telegram 群通知",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "Telegram 群通知",
        "hk": "Telegram 群通知",
        "en": "Telegram"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "rm_tgEnabled"
        },
        {
          "t": "key",
          "key": "rm_tgMode"
        },
        {
          "t": "key",
          "key": "rm_tgToken"
        },
        {
          "t": "key",
          "key": "rm_tgChatId"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "一键绑定 Telegram",
                "hk": "一鍵綁定 Telegram",
                "en": "Link Telegram"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "发送测试消息",
                "hk": "發送測試訊息",
                "en": "Send test"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "飞书群机器人",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "飞书群机器人",
        "hk": "飛書群機械人",
        "en": "Feishu bot"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "rm_fsEnabled"
        },
        {
          "t": "key",
          "key": "rm_fsWebhook"
        },
        {
          "t": "key",
          "key": "rm_fsSecret"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "发送测试消息",
                "hk": "發送測試訊息",
                "en": "Send test"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "Bark（iOS 推送）",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "Bark（iOS 推送）",
        "hk": "Bark（iOS 推送）",
        "en": "Bark (iOS)"
      },
      "sub": {
        "zh": "本页最大的一块：分级规则、三个时机、13 个通用开关、加密推送",
        "hk": "本頁最大的一塊：分級規則、三個時機、13 個通用開關、加密推送",
        "en": "The biggest block: lead rules, three phases, 13 toggles, encrypted push"
      },
      "rows": [
        {
          "t": "key",
          "key": "bk_enabled"
        },
        {
          "t": "key",
          "key": "bk_deviceKey"
        },
        {
          "t": "key",
          "key": "bk_server"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "发送测试推送",
                "hk": "發送測試推送",
                "en": "Send test"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "fold",
          "label": {
            "zh": "提前提醒分级规则（按还剩多久匹配）",
            "hk": "提前提醒分級規則（按還剩多久匹配）",
            "en": "Lead-time rules"
          },
          "name": null,
          "rows": [
            {
              "t": "key",
              "key": "bk_leadRules"
            }
          ]
        },
        {
          "t": "fold",
          "label": {
            "zh": "到点提醒",
            "hk": "到點提醒",
            "en": "Due-time push"
          },
          "name": null,
          "rows": [
            {
              "t": "key",
              "key": "bk_dueLevel"
            },
            {
              "t": "key",
              "key": "bk_dueCall"
            },
            {
              "t": "key",
              "key": "bk_dueCallSeconds"
            },
            {
              "t": "key",
              "key": "bk_dueSoundEnabled"
            },
            {
              "t": "key",
              "key": "bk_dueSound"
            },
            {
              "t": "btns",
              "btns": [
                {
                  "label": {
                    "zh": "试听到点推送",
                    "hk": "試聽到點推送",
                    "en": "Test due push"
                  },
                  "act": null,
                  "primary": false
                }
              ],
              "dep": null
            }
          ]
        },
        {
          "t": "fold",
          "label": {
            "zh": "反复催办",
            "hk": "反復催辦",
            "en": "Nag push"
          },
          "name": null,
          "rows": [
            {
              "t": "key",
              "key": "bk_nagLevel"
            },
            {
              "t": "key",
              "key": "bk_nagCall"
            },
            {
              "t": "key",
              "key": "bk_nagCallSeconds"
            },
            {
              "t": "key",
              "key": "bk_nagSoundEnabled"
            },
            {
              "t": "key",
              "key": "bk_nagSound"
            },
            {
              "t": "key",
              "key": "bk_volume"
            },
            {
              "t": "btns",
              "btns": [
                {
                  "label": {
                    "zh": "试听催办推送",
                    "hk": "試聽催辦推送",
                    "en": "Test nag push"
                  },
                  "act": null,
                  "primary": false
                }
              ],
              "dep": null
            }
          ]
        },
        {
          "t": "fold",
          "label": {
            "zh": "通用开关（13 项）",
            "hk": "通用開關（13 項）",
            "en": "General toggles (13)"
          },
          "name": null,
          "rows": [
            {
              "t": "key",
              "key": "bk_groupEnabled"
            },
            {
              "t": "key",
              "key": "bk_group"
            },
            {
              "t": "key",
              "key": "bk_soundEnabled"
            },
            {
              "t": "key",
              "key": "bk_sound"
            },
            {
              "t": "key",
              "key": "bk_archiveEnabled"
            },
            {
              "t": "key",
              "key": "bk_ttlEnabled"
            },
            {
              "t": "key",
              "key": "bk_ttlSec"
            },
            {
              "t": "key",
              "key": "bk_urlEnabled"
            },
            {
              "t": "key",
              "key": "bk_subtitleEnabled"
            },
            {
              "t": "key",
              "key": "bk_badgeEnabled"
            },
            {
              "t": "key",
              "key": "bk_badge"
            },
            {
              "t": "key",
              "key": "bk_iconEnabled"
            },
            {
              "t": "key",
              "key": "bk_icon"
            },
            {
              "t": "key",
              "key": "bk_imageEnabled"
            },
            {
              "t": "key",
              "key": "bk_image"
            },
            {
              "t": "key",
              "key": "bk_autoCopyEnabled"
            },
            {
              "t": "key",
              "key": "bk_copyEnabled"
            },
            {
              "t": "key",
              "key": "bk_copy"
            },
            {
              "t": "key",
              "key": "bk_actionEnabled"
            },
            {
              "t": "key",
              "key": "bk_action"
            },
            {
              "t": "key",
              "key": "bk_updateByIdEnabled"
            }
          ]
        },
        {
          "t": "fold",
          "label": {
            "zh": "加密推送",
            "hk": "加密推送",
            "en": "Encrypted push"
          },
          "name": null,
          "rows": [
            {
              "t": "key",
              "key": "bk_encryptEnabled"
            },
            {
              "t": "key",
              "key": "bk_encryptAlgorithm"
            },
            {
              "t": "key",
              "key": "bk_encryptKey"
            },
            {
              "t": "key",
              "key": "bk_encryptIv"
            }
          ]
        }
      ]
    },
    {
      "id": "常驻发送（桌面版的备用哨兵服务器）",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "常驻发送（桌面版的备用哨兵服务器）",
        "hk": "常駐發送（桌面版的備用哨兵伺服器）",
        "en": "Always-on sender"
      },
      "sub": {
        "zh": "桌面版要你自己买 VPS、SSH 部署哨兵；网页版天生常驻，这块直接不需要了",
        "hk": "桌面版要你自己買 VPS、SSH 部署哨兵；網頁版天生常駐，這塊直接不需要了",
        "en": "The desktop app needed your own VPS over SSH; the web version is always on"
      },
      "rows": [
        {
          "t": "custom",
          "name": "sentinelBox",
          "dep": null
        },
        {
          "t": "key",
          "key": "vps_keepOwn"
        },
        {
          "t": "key",
          "key": "vs_host"
        },
        {
          "t": "key",
          "key": "vs_port"
        },
        {
          "t": "key",
          "key": "vs_user"
        },
        {
          "t": "key",
          "key": "vs_pass"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "测试连接",
                "hk": "測試連接",
                "en": "Test"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "部署 / 更新哨兵",
                "hk": "部署 / 更新哨兵",
                "en": "Deploy sentinel"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "查看状态",
                "hk": "查看狀態",
                "en": "Status"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": {
            "key": "vps_keepOwn",
            "op": "truthy",
            "value": null
          }
        }
      ]
    },
    {
      "id": "基础设置",
      "page": "reminders",
      "no": null,
      "title": {
        "zh": "基础设置",
        "hk": "基礎設定",
        "en": "Basics"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "rm_enabled"
        },
        {
          "t": "key",
          "key": "rm_style"
        },
        {
          "t": "key",
          "key": "rm_checkInterval"
        },
        {
          "t": "key",
          "key": "rm_fullscreen"
        },
        {
          "t": "key",
          "key": "rm_sound"
        },
        {
          "t": "key",
          "key": "rm_voice"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存事项提醒设置",
                "hk": "儲存事項提醒設定",
                "en": "Save reminder settings"
              },
              "act": null,
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    }
  ],
  "memo": [
    {
      "id": "新增备忘",
      "page": "memo",
      "no": null,
      "title": {
        "zh": "新增备忘",
        "hk": "新增備忘",
        "en": "New note"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "memo_text"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "#灵感",
                "hk": "#靈感",
                "en": "#idea"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "#待跟进",
                "hk": "#待跟進",
                "en": "#todo"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "#合约地址",
                "hk": "#合約地址",
                "en": "#contract"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "#喊单",
                "hk": "#喊單",
                "en": "#caller"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "key",
          "key": "memo_link"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存",
                "hk": "儲存",
                "en": "Save"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "取消编辑",
                "hk": "取消編輯",
                "en": "Cancel"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "备忘列表",
      "page": "memo",
      "no": null,
      "title": {
        "zh": "备忘列表",
        "hk": "備忘列表",
        "en": "Notes"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "usageMemos",
          "dep": null
        },
        {
          "t": "key",
          "key": "memo_filter"
        },
        {
          "t": "key",
          "key": "memo_search"
        },
        {
          "t": "custom",
          "name": "memoTags",
          "dep": null
        },
        {
          "t": "custom",
          "name": "memoList",
          "dep": null
        }
      ]
    }
  ],
  "general": [
    {
      "id": "链热度监控",
      "page": "general",
      "no": null,
      "title": {
        "zh": "链热度监控",
        "hk": "鏈熱度監控",
        "en": "Chain heat"
      },
      "sub": null,
      "rows": [
        {
          "t": "note",
          "text": {
            "zh": "总览页的链热度卡被关掉时，从这里找回设置入口。",
            "hk": "總覽頁的鏈熱度卡被關掉時，從這裏找回設定入口。",
            "en": "If you hide the chain-heat card on the overview, reopen its settings here."
          },
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "打开链热度设置",
                "hk": "開啟鏈熱度設定",
                "en": "Open chain-heat settings"
              },
              "act": "chainCfg",
              "primary": true
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "启动与常驻",
      "page": "general",
      "no": null,
      "title": {
        "zh": "启动与常驻",
        "hk": "啟動與常駐",
        "en": "Startup & presence"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "ge_auto"
        },
        {
          "t": "key",
          "key": "ge_tray"
        },
        {
          "t": "key",
          "key": "ge_extBadge"
        },
        {
          "t": "key",
          "key": "ge_extMenu"
        },
        {
          "t": "key",
          "key": "ge_extNotify"
        }
      ]
    },
    {
      "id": "一键喊话小伙伴（Bark）",
      "page": "general",
      "no": null,
      "title": {
        "zh": "一键喊话小伙伴（Bark）",
        "hk": "一鍵喊話小伙伴（Bark）",
        "en": "Buddy alert (Bark)"
      },
      "sub": {
        "zh": "紧急情况把小伙伴的手机喊醒，突破静音",
        "hk": "緊急情況把小伙伴的手機喊醒，突破靜音",
        "en": "Wake a friend's phone through silent mode"
      },
      "rows": [
        {
          "t": "key",
          "key": "ba_level"
        },
        {
          "t": "key",
          "key": "ba_volume"
        },
        {
          "t": "key",
          "key": "ba_sound"
        },
        {
          "t": "key",
          "key": "ba_callSeconds"
        },
        {
          "t": "key",
          "key": "ba_title"
        },
        {
          "t": "key",
          "key": "ba_body"
        },
        {
          "t": "custom",
          "name": "buddyList",
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "添加小伙伴",
            "hk": "新增小伙伴",
            "en": "Add a buddy"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "bn_name"
        },
        {
          "t": "key",
          "key": "bn_key"
        },
        {
          "t": "key",
          "key": "bn_server"
        },
        {
          "t": "note",
          "text": {
            "zh": "网页版新增：添加后先给对方发一条确认推送，对方点同意才生效；每条喊话都带\"不再接收\"链接；同一个小伙伴每天最多被喊 N 次。",
            "hk": "網頁版新增：新增後先給對方發一條確認推送，對方按同意才生效；每條喊話都帶「不再接收」連結；同一個小伙伴每天最多被喊 N 次。",
            "en": "New in the web version: the buddy must confirm by tapping a link, every push carries an opt-out, and there is a daily cap."
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "ba_dailyCap"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "添加小伙伴",
                "hk": "新增小伙伴",
                "en": "Add buddy"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "保存喊话设置",
                "hk": "儲存喊話設定",
                "en": "Save"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "免打扰 / 游戏模式",
      "page": "general",
      "no": null,
      "title": {
        "zh": "免打扰 / 游戏模式",
        "hk": "免打擾 / 遊戲模式",
        "en": "Do not disturb"
      },
      "sub": {
        "zh": "只能手动开、最长 8 小时、到点自己结束。熔断这类最高一级的提醒照常推送",
        "hk": "只能手動開、最長 8 小時、到點自己結束。熔斷這類最高一級的提醒照常推送",
        "en": "Manual only, 8 hours at most, ends by itself. Top-level alerts such as breakers still come through"
      },
      "rows": [
        {
          "t": "custom",
          "name": "dndState",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "30 分钟",
                "hk": "30 分鐘",
                "en": "30 min"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "1 小时",
                "hk": "1 小時",
                "en": "1 hour"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "2 小时",
                "hk": "2 小時",
                "en": "2 hours"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "4 小时",
                "hk": "4 小時",
                "en": "4 hours"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "立刻关闭",
                "hk": "立刻關閉",
                "en": "Turn off"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "key",
          "key": "dnd_customMin"
        },
        {
          "t": "key",
          "key": "dnd_auto"
        },
        {
          "t": "key",
          "key": "dnd_fsPage"
        },
        {
          "t": "key",
          "key": "dnd_poll"
        },
        {
          "t": "key",
          "key": "dnd_grace"
        },
        {
          "t": "key",
          "key": "dnd_autoMax"
        },
        {
          "t": "sect",
          "text": {
            "zh": "例外与暂存",
            "hk": "例外與暫存",
            "en": "Exceptions & queue"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "dnd_critical"
        },
        {
          "t": "key",
          "key": "dnd_sitting"
        },
        {
          "t": "key",
          "key": "dnd_sittingSilent"
        },
        {
          "t": "key",
          "key": "dnd_queue"
        },
        {
          "t": "key",
          "key": "dnd_digest"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "现在补发",
                "hk": "現在補發",
                "en": "Flush now"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "清空暂存",
                "hk": "清空暫存",
                "en": "Clear queue"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "快捷键",
      "page": "general",
      "no": null,
      "title": {
        "zh": "快捷键",
        "hk": "快捷鍵",
        "en": "Shortcuts"
      },
      "sub": {
        "zh": "桌面版是系统级全局热键；网页版由扩展注册，浏览器内全局有效（游戏里不生效）",
        "hk": "桌面版是系統級全域熱鍵；網頁版由擴充功能註冊，瀏覽器內全域有效（遊戲內不生效）",
        "en": "Desktop used OS-level hotkeys; the extension registers browser-wide ones"
      },
      "rows": [
        {
          "t": "custom",
          "name": "hotkeyList",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "保存快捷键",
                "hk": "儲存快捷鍵",
                "en": "Save"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "全部恢复默认",
                "hk": "全部恢復預設",
                "en": "Reset all"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "声音与语音",
      "page": "general",
      "no": null,
      "title": {
        "zh": "声音与语音",
        "hk": "聲音與語音",
        "en": "Sound & voice"
      },
      "sub": {
        "zh": "桌面版有 Edge / OneCore / SAPI 三级引擎；网页版由服务器合成 Edge 音色，失败退回浏览器自带",
        "hk": "桌面版有 Edge / OneCore / SAPI 三級引擎；網頁版由伺服器合成 Edge 音色，失敗退回瀏覽器內建",
        "en": "Desktop had three TTS engines; the web version synthesizes Edge voices on the server"
      },
      "rows": [
        {
          "t": "key",
          "key": "ge_tone"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "试听提示音",
                "hk": "試聽提示音",
                "en": "Preview sound"
              },
              "act": "tone",
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "key",
          "key": "ge_voice"
        },
        {
          "t": "key",
          "key": "ge_vEngine"
        },
        {
          "t": "key",
          "key": "ge_vEdgeName"
        },
        {
          "t": "key",
          "key": "ge_vMode"
        },
        {
          "t": "key",
          "key": "ge_vPool"
        },
        {
          "t": "key",
          "key": "ge_vol"
        },
        {
          "t": "key",
          "key": "ge_rate"
        },
        {
          "t": "key",
          "key": "ge_vPitch"
        },
        {
          "t": "key",
          "key": "ge_vTestText"
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "试听",
                "hk": "試聽",
                "en": "Preview"
              },
              "act": "speak",
              "primary": true
            },
            {
              "label": {
                "zh": "逐个试听所有中文音色",
                "hk": "逐個試聽所有中文音色",
                "en": "Audition all"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "拉取完整音色库",
                "hk": "拉取完整音色庫",
                "en": "Fetch full library"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "语音缓存",
            "hk": "語音快取",
            "en": "Voice cache"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "ge_vPrewarm"
        },
        {
          "t": "custom",
          "name": "voiceCache",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "立刻预热全部提醒语",
                "hk": "立刻預熱全部提醒語",
                "en": "Prewarm now"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "清空语音缓存",
                "hk": "清空語音快取",
                "en": "Clear cache"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "sect",
          "text": {
            "zh": "全局静音时段",
            "hk": "全域靜音時段",
            "en": "Global quiet hours"
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "ge_quiet"
        },
        {
          "t": "key",
          "key": "ge_qfrom"
        },
        {
          "t": "key",
          "key": "ge_qto"
        }
      ]
    },
    {
      "id": "界面折叠",
      "page": "general",
      "no": null,
      "title": {
        "zh": "界面折叠",
        "hk": "介面摺疊",
        "en": "Card folding"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "全部展开",
                "hk": "全部展開",
                "en": "Expand all"
              },
              "act": "foldAll",
              "primary": false
            },
            {
              "label": {
                "zh": "全部折叠",
                "hk": "全部摺疊",
                "en": "Collapse all"
              },
              "act": "foldNone",
              "primary": false
            },
            {
              "label": {
                "zh": "恢复默认折叠状态",
                "hk": "恢復預設摺疊狀態",
                "en": "Reset folding"
              },
              "act": "foldReset",
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "操作习惯",
      "page": "general",
      "no": null,
      "title": {
        "zh": "操作习惯",
        "hk": "操作習慣",
        "en": "Working habits"
      },
      "sub": {
        "zh": "快捷键、延后选项、提示条停留多久、要不要二次确认。按你的手感来调。",
        "hk": "快捷鍵、延後選項、提示條停留多久、要不要二次確認。按你的手感來調。",
        "en": "Shortcuts, snooze choices, toast timing and confirmations."
      },
      "rows": [
        {
          "t": "key",
          "key": "ux_hk"
        },
        {
          "t": "key",
          "key": "ux_gnav"
        },
        {
          "t": "key",
          "key": "ix_next"
        },
        {
          "t": "key",
          "key": "ix_prev"
        },
        {
          "t": "key",
          "key": "ix_ack"
        },
        {
          "t": "key",
          "key": "ix_snooze"
        },
        {
          "t": "key",
          "key": "ix_done"
        },
        {
          "t": "key",
          "key": "ix_snoozeDef"
        },
        {
          "t": "key",
          "key": "ux_snoozeList"
        },
        {
          "t": "key",
          "key": "ux_toastSec"
        },
        {
          "t": "key",
          "key": "ux_confirmDanger"
        }
      ]
    },
    {
      "id": "数据与维护",
      "page": "general",
      "no": null,
      "title": {
        "zh": "数据与维护",
        "hk": "資料與維護",
        "en": "Data & maintenance"
      },
      "sub": {
        "zh": "桌面版存本地 JSON；网页版存服务器数据库，并补上桌面版没有的导入导出",
        "hk": "桌面版存本機 JSON；網頁版存伺服器資料庫，並補上桌面版沒有的匯入匯出",
        "en": "Desktop stored local JSON; the web version uses a database and adds the import/export the desktop app lacked"
      },
      "rows": [
        {
          "t": "custom",
          "name": "storageInfo",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "导出全部数据（JSON）",
                "hk": "匯出全部資料（JSON）",
                "en": "Export all (JSON)"
              },
              "act": null,
              "primary": true
            },
            {
              "label": {
                "zh": "导出交易记录（CSV）",
                "hk": "匯出交易記錄（CSV）",
                "en": "Export trades (CSV)"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "导出备忘录",
                "hk": "匯出備忘錄",
                "en": "Export notes"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "导入数据",
                "hk": "匯入資料",
                "en": "Import"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "恢复默认设置",
                "hk": "恢復預設設定",
                "en": "Reset to defaults"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "删除账号和全部数据",
                "hk": "刪除帳戶及全部資料",
                "en": "Delete account"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    }
  ],
  "system": [
    {
      "id": "一键运行自检",
      "page": "system",
      "no": null,
      "title": {
        "zh": "一键运行自检",
        "hk": "一鍵執行自檢",
        "en": "Run self-test"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "开始自检",
                "hk": "開始自檢",
                "en": "Start"
              },
              "act": "selftest",
              "primary": true
            }
          ],
          "dep": null
        },
        {
          "t": "custom",
          "name": "selfTest",
          "dep": null
        }
      ]
    },
    {
      "id": "测试提醒效果（点了会真的弹出来）",
      "page": "system",
      "no": null,
      "title": {
        "zh": "测试提醒效果（点了会真的弹出来）",
        "hk": "測試提醒效果（按了會真的彈出來）",
        "en": "Test the alerts (they really fire)"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "耐心提醒",
                "hk": "耐心提醒",
                "en": "Patience"
              },
              "act": "testPatience",
              "primary": false
            },
            {
              "label": {
                "zh": "久坐提醒",
                "hk": "久坐提醒",
                "en": "Sitting"
              },
              "act": "testSitting",
              "primary": false
            },
            {
              "label": {
                "zh": "利润锁死弹窗",
                "hk": "利潤鎖死彈窗",
                "en": "Profit lock"
              },
              "act": "testProfit",
              "primary": false
            },
            {
              "label": {
                "zh": "每日心法",
                "hk": "每日心法",
                "en": "Daily creed"
              },
              "act": "testCreed",
              "primary": false
            },
            {
              "label": {
                "zh": "下单前确认",
                "hk": "下單前確認",
                "en": "Pre-trade checklist"
              },
              "act": "testChecklist",
              "primary": false
            },
            {
              "label": {
                "zh": "熔断锁屏（全屏）",
                "hk": "熔斷鎖屏（全螢幕）",
                "en": "Breaker lock"
              },
              "act": "testLock",
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "怎么判断程序在正常保护我",
      "page": "system",
      "no": null,
      "title": {
        "zh": "怎么判断程序在正常保护我",
        "hk": "怎麼判斷程式在正常保護我",
        "en": "How to tell it is protecting you"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "proofTable",
          "dep": null
        }
      ]
    },
    {
      "id": "一键全面检测",
      "page": "system",
      "no": null,
      "title": {
        "zh": "一键全面检测",
        "hk": "一鍵全面檢測",
        "en": "Full health check"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "开始检测",
                "hk": "開始檢測",
                "en": "Start"
              },
              "act": "diag",
              "primary": true
            }
          ],
          "dep": null
        },
        {
          "t": "custom",
          "name": "diagResult",
          "dep": null
        }
      ]
    },
    {
      "id": "常见问题一键修复",
      "page": "system",
      "no": null,
      "title": {
        "zh": "常见问题一键修复",
        "hk": "常見問題一鍵修復",
        "en": "One-click fixes"
      },
      "sub": null,
      "rows": [
        {
          "t": "note",
          "text": {
            "zh": "桌面版这里修的是：装 gmgn-cli、自动升级、禁用 IPv6、修 PATH、扫代理端口。网页版这些都在服务器上，由我们运维，你这边只看结果。",
            "hk": "桌面版這裏修的是：安裝 gmgn-cli、自動升級、停用 IPv6、修 PATH、掃代理通訊埠。網頁版這些都在伺服器上，由我們運維，你這邊只看結果。",
            "en": "The desktop app fixed local environment issues. On the web these live on the server and we operate them."
          },
          "dep": null
        },
        {
          "t": "custom",
          "name": "serverHealth",
          "dep": null
        },
        {
          "t": "key",
          "key": "cu_enabled"
        },
        {
          "t": "key",
          "key": "cu_mode"
        },
        {
          "t": "key",
          "key": "cu_interval"
        }
      ]
    },
    {
      "id": "手动排查清单",
      "page": "system",
      "no": null,
      "title": {
        "zh": "手动排查清单",
        "hk": "手動排查清單",
        "en": "Manual troubleshooting"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "troubleTable",
          "dep": null
        }
      ]
    },
    {
      "id": "纪律执行记录",
      "page": "system",
      "no": null,
      "title": {
        "zh": "纪律执行记录",
        "hk": "紀律執行記錄",
        "en": "Discipline journal"
      },
      "sub": null,
      "rows": [
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "刷新",
                "hk": "重新整理",
                "en": "Refresh"
              },
              "act": null,
              "primary": false
            },
            {
              "label": {
                "zh": "导出记录",
                "hk": "匯出記錄",
                "en": "Export"
              },
              "act": null,
              "primary": false
            }
          ],
          "dep": null
        },
        {
          "t": "custom",
          "name": "journal",
          "dep": null
        }
      ]
    }
  ],
  "look": [
    {
      "id": "主题",
      "page": "look",
      "no": null,
      "title": {
        "zh": "主题",
        "hk": "主題",
        "en": "Theme"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "theme"
        }
      ]
    },
    {
      "id": "图标",
      "page": "look",
      "no": null,
      "title": {
        "zh": "图标",
        "hk": "圖標",
        "en": "Icons"
      },
      "sub": {
        "zh": "四套风格。前两套是设计师做好的开源双色图标集，后两套是内置自绘的，断网时兜底用。",
        "hk": "四套風格。前兩套是設計師做好的開源雙色圖標集，後兩套是內建自繪的，斷網時兜底用。",
        "en": "Four styles: two open-source duotone sets, two built-in fallbacks."
      },
      "rows": [
        {
          "t": "key",
          "key": "iconstyle"
        },
        {
          "t": "key",
          "key": "iconweight"
        },
        {
          "t": "custom",
          "name": "iconPreview",
          "dep": null
        }
      ]
    },
    {
      "id": "用自己的图标",
      "page": "look",
      "no": null,
      "title": {
        "zh": "用自己的图标",
        "hk": "用自己的圖標",
        "en": "Your own icons"
      },
      "sub": {
        "zh": "界面里 59 个图标位，每一个都能换成你自己的图。支持一次拖一堆进来按文件名自动配对，也能直接搜开源图标库。",
        "hk": "介面裏 59 個圖標位，每一個都能換成你自己的圖。支援一次拖一堆進來按檔名自動配對，也能直接搜開源圖標庫。",
        "en": "All 59 icon slots can use your own files. Drop a batch to match by name, or search open-source sets."
      },
      "rows": [
        {
          "t": "custom",
          "name": "userIcons",
          "dep": null
        },
        {
          "t": "custom",
          "name": "usageIcons",
          "dep": null
        }
      ]
    },
    {
      "id": "强调色",
      "page": "look",
      "no": null,
      "title": {
        "zh": "强调色",
        "hk": "強調色",
        "en": "Accent colour"
      },
      "sub": {
        "zh": "默认跟着主题走。想单独换一个也行，换完会自动检查对比度。",
        "hk": "預設跟着主題走。想單獨換一個也行，換完會自動檢查對比度。",
        "en": "Follows the theme by default."
      },
      "rows": [
        {
          "t": "key",
          "key": "accent"
        }
      ]
    },
    {
      "id": "手感",
      "page": "look",
      "no": null,
      "title": {
        "zh": "手感",
        "hk": "手感",
        "en": "Feel"
      },
      "sub": {
        "zh": "鼠标经过、按下去、键盘聚焦时的反应。每套配色自带一档，也可以自己换。",
        "hk": "滑鼠經過、按下去、鍵盤聚焦時的反應。每套配色自帶一檔，也可以自己換。",
        "en": "How hover, press and focus respond. Each palette ships its own default."
      },
      "rows": [
        {
          "t": "key",
          "key": "feel"
        },
        {
          "t": "custom",
          "name": "feelPreview",
          "dep": null
        },
        {
          "t": "key",
          "key": "cursor"
        },
        {
          "t": "key",
          "key": "btnfill"
        },
        {
          "t": "key",
          "key": "textc"
        }
      ]
    },
    {
      "id": "显示",
      "page": "look",
      "no": null,
      "title": {
        "zh": "显示",
        "hk": "顯示",
        "en": "Display"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "updown"
        },
        {
          "t": "key",
          "key": "updownmark"
        },
        {
          "t": "key",
          "key": "density"
        },
        {
          "t": "key",
          "key": "font"
        },
        {
          "t": "key",
          "key": "layout"
        },
        {
          "t": "key",
          "key": "radius"
        },
        {
          "t": "key",
          "key": "numfmt"
        },
        {
          "t": "key",
          "key": "motion"
        },
        {
          "t": "key",
          "key": "speed"
        },
        {
          "t": "key",
          "key": "hoverfx"
        },
        {
          "t": "key",
          "key": "glow"
        },
        {
          "t": "custom",
          "name": "lookPreview",
          "dep": null
        },
        {
          "t": "btns",
          "btns": [
            {
              "label": {
                "zh": "恢复默认外观",
                "hk": "恢復預設外觀",
                "en": "Reset appearance"
              },
              "act": "resetLook",
              "primary": false
            }
          ],
          "dep": null
        }
      ]
    },
    {
      "id": "排版细调",
      "page": "look",
      "no": null,
      "title": {
        "zh": "排版细调",
        "hk": "排版細調",
        "en": "Typography & spacing"
      },
      "sub": {
        "zh": "信息密度改的是整体，这里能单独调某一项。",
        "hk": "資訊密度改的是整體，這裏能單獨調某一項。",
        "en": "Density changes everything at once; these are per-item."
      },
      "rows": [
        {
          "t": "key",
          "key": "lh"
        },
        {
          "t": "key",
          "key": "tbl"
        },
        {
          "t": "key",
          "key": "fontface"
        },
        {
          "t": "key",
          "key": "numface"
        },
        {
          "t": "key",
          "key": "tabnum"
        },
        {
          "t": "key",
          "key": "maxw"
        },
        {
          "t": "key",
          "key": "sidew"
        }
      ]
    },
    {
      "id": "质感",
      "page": "look",
      "no": null,
      "title": {
        "zh": "质感",
        "hk": "質感",
        "en": "Surfaces"
      },
      "sub": {
        "zh": "默认是编辑式的做法：不画框、不打阴影，靠留白和一条细线分组。",
        "hk": "預設是編輯式的做法：不畫框、不打陰影，靠留白和一條細線分組。",
        "en": "Defaults follow editorial practice: no frames, no shadows, just space and a hairline."
      },
      "rows": [
        {
          "t": "key",
          "key": "cardstyle"
        },
        {
          "t": "key",
          "key": "chip"
        },
        {
          "t": "key",
          "key": "display"
        },
        {
          "t": "key",
          "key": "caps"
        },
        {
          "t": "key",
          "key": "shadow"
        },
        {
          "t": "key",
          "key": "focus"
        }
      ]
    },
    {
      "id": "布局自定义",
      "page": "look",
      "no": null,
      "title": {
        "zh": "布局自定义",
        "hk": "佈局自訂",
        "en": "Custom layout"
      },
      "sub": {
        "zh": "每一块的位置都能自己排。顺序跟着账号走，换电脑还在。",
        "hk": "每一塊的位置都能自己排。順序跟着帳戶走，換電腦還在。",
        "en": "Rearrange every block; the order follows your account."
      },
      "rows": [
        {
          "t": "custom",
          "name": "layoutPanel",
          "dep": null
        }
      ]
    },
    {
      "id": "导航",
      "page": "look",
      "no": null,
      "title": {
        "zh": "导航",
        "hk": "導航",
        "en": "Navigation"
      },
      "sub": {
        "zh": "侧栏的顺序、藏掉用不到的页面、手机底栏放哪 5 个。",
        "hk": "側欄的順序、藏掉用不到的頁面、手機底欄放哪 5 個。",
        "en": "Sidebar order, hidden pages, and the five phone tabs."
      },
      "rows": [
        {
          "t": "custom",
          "name": "navEditor",
          "dep": null
        }
      ]
    },
    {
      "id": "语言与地区",
      "page": "look",
      "no": null,
      "title": {
        "zh": "语言与地区",
        "hk": "語言與地區",
        "en": "Language & region"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "lang"
        },
        {
          "t": "key",
          "key": "tz"
        },
        {
          "t": "key",
          "key": "resetAt"
        },
        {
          "t": "key",
          "key": "clock"
        },
        {
          "t": "key",
          "key": "voiceFollow"
        },
        {
          "t": "custom",
          "name": "langPreview",
          "dep": null
        }
      ]
    },
    {
      "id": "账号与安全",
      "page": "look",
      "no": null,
      "title": {
        "zh": "账号与安全",
        "hk": "帳戶與安全",
        "en": "Account & security"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "loginMethods",
          "dep": null
        },
        {
          "t": "custom",
          "name": "deviceList",
          "dep": null
        },
        {
          "t": "note",
          "text": {
            "zh": "我们永远不会索要你的助记词或钱包私钥。GMGN 只读 Key 加密保存，页面只显示末 4 位。",
            "hk": "我們永遠不會索取你的助記詞或錢包私鑰。GMGN 唯讀 Key 加密儲存，頁面只顯示末 4 位。",
            "en": "We never ask for your seed phrase or wallet private key. Read-only GMGN keys are encrypted and masked."
          },
          "dep": null
        }
      ]
    }
  ],
  "billing": [
    {
      "id": "当前状态",
      "page": "billing",
      "no": null,
      "title": {
        "zh": "当前状态",
        "hk": "當前狀態",
        "en": "Current plan"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "planStatus",
          "dep": null
        }
      ]
    },
    {
      "id": "免费版和 VIP 差在哪",
      "page": "billing",
      "no": null,
      "title": {
        "zh": "免费版和 VIP 差在哪",
        "hk": "免費版和 VIP 差在哪",
        "en": "Free vs VIP"
      },
      "sub": {
        "zh": "功能完全一样，差别只在能同时盯多少个。16 条纪律、所有提醒方式、所有外观，免费版全都有。",
        "hk": "功能完全一樣，差別只在能同時盯多少個。16 條紀律、所有提醒方式、所有外觀，免費版全都有。",
        "en": "Same features. VIP just lets you watch more at once."
      },
      "rows": [
        {
          "t": "custom",
          "name": "planCompare",
          "dep": null
        }
      ]
    },
    {
      "id": "买 VIP",
      "page": "billing",
      "no": null,
      "title": {
        "zh": "买 VIP",
        "hk": "買 VIP",
        "en": "Get VIP"
      },
      "sub": {
        "zh": "年付比按月付省 32 U。首发期可以先免费领，领过的到期再决定买不买。",
        "hk": "年付比按月付省 32 U。首發期可以先免費領，領過的到期再決定買不買。",
        "en": "Yearly saves 32 U over monthly. During launch you can claim it free first."
      },
      "rows": [
        {
          "t": "custom",
          "name": "planPicker",
          "dep": null
        },
        {
          "t": "key",
          "key": "bill_chain"
        },
        {
          "t": "key",
          "key": "bill_token"
        },
        {
          "t": "custom",
          "name": "payQr",
          "dep": null
        }
      ]
    },
    {
      "id": "历史订单",
      "page": "billing",
      "no": null,
      "title": {
        "zh": "历史订单",
        "hk": "歷史訂單",
        "en": "Orders"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "orderList",
          "dep": null
        }
      ]
    },
    {
      "id": "VIP 到期之后会怎样",
      "page": "billing",
      "no": null,
      "title": {
        "zh": "VIP 到期之后会怎样",
        "hk": "VIP 到期之後會怎樣",
        "en": "When VIP ends"
      },
      "sub": {
        "zh": "说清楚比让你猜好：回到免费版，什么都不会丢。",
        "hk": "說清楚比讓你猜好：回到免費版，甚麼都不會丟。",
        "en": "You simply return to Free. Nothing is lost."
      },
      "rows": [
        {
          "t": "note",
          "text": {
            "zh": "风控一直在跑：16 条纪律、熔断、提醒全部照常，免费版都有。",
            "hk": "風控一直在跑：16 條紀律、熔斷、提醒全部照常，免費版都有。",
            "en": "Risk control never stops: every rule, breaker and alert keeps running on Free."
          },
          "dep": null
        },
        {
          "t": "note",
          "text": {
            "zh": "超出免费版数量的钱包、代币、链先暂停，设置全都留着，再开 VIP 自动恢复。",
            "hk": "超出免費版數量的錢包、代幣、鏈先暫停，設定全都留着，再開 VIP 自動恢復。",
            "en": "Anything above the Free limits is paused, not deleted, and comes back with VIP."
          },
          "dep": null
        },
        {
          "t": "note",
          "text": {
            "zh": "不会自动扣钱。链上付款本来就是你自己转账，没有代扣这回事。",
            "hk": "不會自動扣錢。鏈上付款本來就是你自己轉賬，沒有代扣這回事。",
            "en": "No automatic charges. On-chain payment is always a transfer you make yourself."
          },
          "dep": null
        },
        {
          "t": "key",
          "key": "bill_expireNotify"
        }
      ]
    }
  ],
  "referral": [
    {
      "id": "我的邀请链接",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "我的邀请链接",
        "hk": "我的邀請連結",
        "en": "Your link"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "refLink",
          "dep": null
        }
      ]
    },
    {
      "id": "战绩",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "战绩",
        "hk": "戰績",
        "en": "Performance"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "refStats",
          "dep": null
        }
      ]
    },
    {
      "id": "越邀越多，比例越高",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "越邀越多，比例越高",
        "hk": "越邀越多，比例越高",
        "en": "Invite more, earn more"
      },
      "sub": {
        "zh": "只往上调，不回溯。升档之后的每一单都按新比例。",
        "hk": "只往上調，不回溯。升檔之後的每一單都按新比例。",
        "en": "Rates only go up and never apply backwards."
      },
      "rows": [
        {
          "t": "custom",
          "name": "refLadder",
          "dep": null
        }
      ]
    },
    {
      "id": "返佣怎么拿",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "返佣怎么拿",
        "hk": "返佣怎麼拿",
        "en": "Cash out"
      },
      "sub": {
        "zh": "两个出口，随你选。折成时长更划算，提现也很方便。",
        "hk": "兩個出口，隨你選。折成時長更划算，提現也很方便。",
        "en": "Two ways. Time is the better deal; cash is easy too."
      },
      "rows": [
        {
          "t": "custom",
          "name": "refCashout",
          "dep": null
        }
      ]
    },
    {
      "id": "明细",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "明细",
        "hk": "明細",
        "en": "History"
      },
      "sub": null,
      "rows": [
        {
          "t": "key",
          "key": "ref_filter"
        },
        {
          "t": "custom",
          "name": "refList",
          "dep": null
        }
      ]
    },
    {
      "id": "规则说明",
      "page": "referral",
      "no": null,
      "title": {
        "zh": "规则说明",
        "hk": "規則說明",
        "en": "How it works"
      },
      "sub": null,
      "rows": [
        {
          "t": "custom",
          "name": "refRules",
          "dep": null
        }
      ]
    }
  ],
  "ext": []
};
